import { HttpClient } from '@angular/common/http';
import { Inject, Injectable, InjectionToken } from '@angular/core';
import { Router } from '@angular/router';

import { Observable } from 'rxjs';

import { environment } from '../../../environments/environment';
import { UserInfo } from '../../models/user-info.model';

export interface Auth {
  operationMessage: string;
  operationStatus: string;
  item?: Item;
}

export interface Item{
  autorisations: string[];
  firstName: string;
  lastName: string;
  roles: string[];
  token: string;
  userId: string;
}

export const WINDOW = new InjectionToken<Window>('Window');

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  isLoggedIn = false;
  idNatps: string;
  idSub: string;
  userType: string;
  userInfo: UserInfo;

  constructor(
    @Inject(WINDOW) private readonly window: Window,
    protected readonly http: HttpClient,
    protected readonly router: Router
  ) {}

  /**
   * Logout user (keep cookies when a user is not connected and have already accepted the cookies before.)
   */
  logout() {
    const cookies = sessionStorage.getItem('cookies_accepted');
    sessionStorage.clear();
    sessionStorage.setItem('cookies_accepted', cookies);
    this.getDeconnexion().subscribe();
    this.window.location.href = '/logoutps';
  }

  getUserInfo(): Observable<any> {
    return this.http.get<UserInfo>(`${environment.API_URL}userInfos`);
  }

  getAuth(): Observable<Auth> {
    return this.http.post<Auth>(`${environment.API_URL}session`,{});
  }

  getDeconnexion(): Observable<any> {
    return this.http.post<any>(`${environment.API_URL}logout`,{});
  }

}
